import UserServicesFactory from '../../user/Services/factory.js'
import CheckoutErrorsFactory from '../Errors/factory.js'
import CheckoutRepositoryFactory from '../Repositories/factory.js'
import CreateOrderCheckoutUseCase from './CreateOrderCheckoutUseCase.js'
import GetPaymentMethodsCheckoutUseCase from './GetPaymentMethodsCheckoutUseCase.js'
import PurchaseCheckoutUseCase from './PurchaseCheckoutUseCase.js'
import PurchaseDetailsCheckoutUseCase from './PurchaseDetailsCheckoutUseCase.js'

export default class CheckoutUseCasesFactory {
  static getPaymentMethodsCheckoutUseCase = ({config}) =>
    new GetPaymentMethodsCheckoutUseCase({
      repository: CheckoutRepositoryFactory.hTTPCheckoutRepository({
        config
      }),
      getPaymentMethodsCheckoutError: CheckoutErrorsFactory.getPaymentMethodsCheckoutError
    })

  static createOrderCheckoutUseCase = ({config}) =>
    new CreateOrderCheckoutUseCase({
      repository: CheckoutRepositoryFactory.hTTPCheckoutRepository({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      createOrderCheckoutError: CheckoutErrorsFactory.createOrderCheckoutError
    })

  static purchaseCheckoutUseCase = ({config}) =>
    new PurchaseCheckoutUseCase({
      repository: CheckoutRepositoryFactory.hTTPCheckoutRepository({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      purchaseCheckoutError: CheckoutErrorsFactory.purchaseCheckoutError
    })

  static purchaseDetailsCheckoutUseCase = ({config}) =>
    new PurchaseDetailsCheckoutUseCase({
      repository: CheckoutRepositoryFactory.hTTPCheckoutRepository({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      purchaseDetailsCheckoutError: CheckoutErrorsFactory.purchaseDetailsCheckoutError
    })
}
